<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')" style="cursor: pointer">Contabilidad</li>
        <li class="breadcrumb-item active">Balance de Proyectos</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vx-card>
            <h3>Proyecto</h3>
            <vs-row vs-justify="center">
              <vs-col vs-justify="left" vs-align="left" vs-w="11">
                <vs-input type="number" size="large" color="warning" style="width: 100%"
                          placeholder="ID de Proyecto (PID)..." v-model="project_id"
                          v-on:keyup.enter="searchProject()"/>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="1">
                <vs-button size="large" style="margin-left: 35%;" color="warning" type="filled" icon="search"
                           v-on:click="searchProject()" :disabled="buscando"></vs-button>
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <vs-col>
          <vx-card>
            <h5 id="validaciones">Validaciones</h5>
            <table class="table table-hover" aria-describedby="validaciones" style="border: solid;">
              <thead class="thead-dark">
              <tr>
                <th class="header" scope="col" style="text-align: left!important">Proceso</th>
                <th class="header" scope="col" style="text-align: center!important">Descripción</th>
                <th class="header" scope="col" style="text-align: center!important">Valor A</th>
                <th class="header" scope="col" style="text-align: center!important">Valor B</th>
                <th class="header" scope="col" style="text-align: center!important; background-color: #003300">Valor A
                </th>
                <th class="header" scope="col" style="text-align: center!important; background-color: #003300">Valor B
                </th>
                <th class="header" scope="col" style="text-align: center!important; background-color: #003300">
                  Resultado
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="renglon in validaciones" style="border: solid;">
                <td>{{ renglon.proceso }}</td>
                <td>{{ renglon.descripcion }}</td>
                <td>{{ renglon.valora }}</td>
                <td>{{ renglon.valorb }}</td>
                <td>{{ formatPrice(renglon.a, 2) }}</td>
                <td>{{ formatPrice(renglon.b, 2) }}</td>
                <td>
                  <em class="material-icons" v-if="renglon.resultado" style="color: green">check_circle</em>
                  <em class="material-icons" v-else style="color: red">cancel</em>
                </td>
              </tr>
              </tbody>
            </table>
          </vx-card>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <vs-col>
          <vx-card>
            <h5 id="balance">Balance</h5>
            <table class="table table-hover" aria-describedby="balance" style="border: solid;">
              <thead class="thead-dark">
              <tr>
                <th class="header" scope="col" style="border-left: solid black"></th>
                <th class="header" scope="col"></th>
                <th class="header" scope="col" colspan="2" style="text-align: center !important;">Inversionista</th>
                <th class="header" scope="col" colspan="2" style="text-align: center !important">Cliente</th>
                <th class="header" scope="col" colspan="2" style="text-align: center !important">Proveedor</th>
                <th class="header" scope="col" colspan="2"
                    style="text-align: center !important; border-right: solid black;">RedGirasol
                </th>
              </tr>
              <tr>
                <th class="header" scope="col" style="text-align: left!important; border-left: solid black;">Concepto
                </th>
                <th class="header" scope="col" style="text-align: center!important">TRX</th>
                <th class="header" scope="col" style="text-align: center!important">Ing</th>
                <th class="header" scope="col" style="text-align: center!important">Egr</th>
                <th class="header" scope="col" style="text-align: center!important">Ing</th>
                <th class="header" scope="col" style="text-align: center!important">Egr</th>
                <th class="header" scope="col" style="text-align: center!important">Ing</th>
                <th class="header" scope="col" style="text-align: center!important">Egr</th>
                <th class="header" scope="col" style="text-align: center!important">Ing</th>
                <th class="header" scope="col" style="text-align: center!important; border-right: solid black;">Egr</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border-bottom: solid"> <!-- Fondeo e Instalación -->
                <td v-on:click="function(){if(f) f=false; else f=true;}" colspan="2"
                    style="cursor:pointer; font-weight: bold !important; border: solid;">Fondeo e Instalación <em
                  style="float: right;" class="material-icons" v-if="f">arrow_drop_down</em><em style="float: right;"
                                                                                                class="material-icons"
                                                                                                v-else>arrow_right</em>
                </td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalFondeoII, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalFondeoIE, 2) }}
                </td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalFondeoCI, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalFondeoCE, 2) }}
                </td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalFondeoSI, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalFondeoSE, 2) }}
                </td>
                <td style="text-align: center!important"></td>
                <td style="text-align: center!important; border-right: solid;border-left: dashed 1px;"></td>
              </tr>
              <tr v-for="renglon in fondeo" v-if="f">
                <td style="border-left: solid;border-right: solid;">{{ renglon.concept }}</td>
                <td style="text-align: center!important;border-right: solid;">{{ renglon.trx_type }}</td>
                <td style="text-align: center!important" v-for="(cant,index) in renglon.amounts"
                    :style="(index%2==1) ? 'border-right:solid; border-left: dashed 1px;':''"><span
                  v-if="cant!=''">{{ formatPrice(cant, 2) }}</span></td>
              </tr>
              <tr style="border-bottom: solid; border-top: solid"> <!-- Comisiones Cliente -->
                <td v-on:click="function(){if(c) c=false; else c=true;}" colspan="2"
                    style="cursor:pointer; font-weight: bold !important; border-right: solid; border-left: solid;">
                  Comisiones Cliente <em style="float: right;" class="material-icons" v-if="c">arrow_drop_down</em><em
                  style="float: right;" class="material-icons" v-else>arrow_right</em></td>
                <td style="text-align: center!important"></td>
                <td style="text-align: center!important; border-right: solid;border-left: dashed 1px;"></td>
                <td style="text-align: center!important"></td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalClienteCE, 2) }}
                </td>
                <td style="text-align: center!important"></td>
                <td style="text-align: center!important; border-right: solid;border-left: dashed 1px;"></td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalClienteRI, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalClienteRE, 2) }}
                </td>
              </tr>
              <tr v-for="renglon in cliente" v-if="c">
                <td style="border-left: solid;border-right: solid;">{{ renglon.concept }}</td>
                <td style="text-align: center!important;border-right: solid;">{{ renglon.trx_type }}</td>
                <td style="text-align: center!important" v-for="(cant,index) in renglon.amounts"
                    :style="(index%2==1) ? 'border-right:solid; border-left: dashed 1px;':''"><span
                  v-if="cant!=''">{{ formatPrice(cant, 2) }}</span></td>
              </tr>
              <tr style="border-bottom: solid; border-top: solid"> <!-- Comisiones Instalador -->
                <td v-on:click="function(){if(i) i=false; else i=true;}" colspan="2"
                    style="cursor:pointer; font-weight: bold !important; border-right: solid; border-left: solid;">
                  Comisiones Instalador <em style="float: right;" class="material-icons"
                                            v-if="i">arrow_drop_down</em><em style="float: right;"
                                                                             class="material-icons"
                                                                             v-else>arrow_right</em></td>
                <td style="text-align: center!important"></td>
                <td style="text-align: center!important; border-right: solid;border-left: dashed 1px;"></td>
                <td style="text-align: center!important"></td>
                <td style="text-align: center!important; border-right: solid;border-left: dashed 1px;"></td>
                <td style="text-align: center!important"></td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalSupplierSE, 2) }}
                </td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalSupplierRI, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalSupplierRE, 2) }}
                </td>
              </tr>
              <tr v-for="renglon in instalador" v-if="i">
                <td style="border-left: solid;border-right: solid;">{{ renglon.concept }}</td>
                <td style="text-align: center!important;border-right: solid;">{{ renglon.trx_type }}</td>
                <td style="text-align: center!important" v-for="(cant,index) in renglon.amounts"
                    :style="(index%2==1) ? 'border-right:solid; border-left: dashed 1px;':''"><span
                  v-if="cant!=''">{{ formatPrice(cant, 2) }}</span></td>
              </tr>
              <tr style="border-bottom: solid; border-top: solid"> <!-- Mensualidades -->
                <td v-on:click="function(){if(m) m=false; else m=true;}" colspan="2"
                    style="cursor:pointer; font-weight: bold !important;border-right: solid; border-left: solid;">
                  Mensualidades <em style="float: right;" class="material-icons" v-if="m">arrow_drop_down</em><em
                  style="float: right;" class="material-icons" v-else>arrow_right</em></td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalMensII, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalMensIE, 2) }}
                </td>
                <td style="text-align: center!important"></td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalMensCE, 2) }}
                </td>
                <td style="text-align: center!important"></td>
                <td style="text-align: center!important; border-right: solid;border-left: dashed 1px;"></td>
                <td style="text-align: center!important; font-weight: bold !important">
                  {{ formatPrice(totalMensRI, 2) }}
                </td>
                <td
                  style="text-align: center!important; font-weight: bold !important; border-right: solid;border-left: dashed 1px;">
                  {{ formatPrice(totalMensRE, 2) }}
                </td>
              </tr>
              <tr v-for="renglon in mensualidades" v-if="m">
                <td style="border-left: solid;border-right: solid;">{{ renglon.concept }}</td>
                <td style="text-align: center!important;border-right: solid;">{{ renglon.trx_type }}</td>
                <td style="text-align: center!important" v-for="(cant,index) in renglon.amounts"
                    :style="(index%2==1) ? 'border-right:solid; border-left: dashed 1px;':''"><span
                  v-if="cant!=''">{{ formatPrice(cant, 2) }}</span></td>
              </tr>
              </tbody>
            </table>
          </vx-card>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script lang="js">
import {Currency} from "@/models/Security/Currency";

export default {
  name: 'project-balance',
  props: ['project'],
  data() {
    return {
      buscando: false,
      project_id: null,
      fondeo: [],
      cliente: [],
      instalador: [],
      mensualidades: [],
      validaciones: [],
      totalFondeoII: 0,
      totalFondeoIE: 0,
      totalFondeoCI: 0,
      totalFondeoCE: 0,
      totalFondeoSI: 0,
      totalFondeoSE: 0,
      totalClienteCE: 0,
      totalClienteRI: 0,
      totalClienteRE: 0,
      totalSupplierSE: 0,
      totalSupplierRI: 0,
      totalSupplierRE: 0,
      totalMensII: 0,
      totalMensIE: 0,
      totalMensCE: 0,
      totalMensRI: 0,
      totalMensRE: 0,
      f: false,
      c: false,
      i: false,
      m: false,
    }
  },
  methods: {
    formatPrice(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(',', '.')
      return Currency.format(parseFloat(val))
    },
    searchProject() {
      this.buscando = true;

      this.validaciones = [];
      this.fondeo = [];
      this.cliente = [];
      this.instalador = [];
      this.mensualidades = [];
      this.totalFondeoII = 0;
      this.totalFondeoIE = 0;
      this.totalFondeoCI = 0;
      this.totalFondeoCE = 0;
      this.totalFondeoSI = 0;
      this.totalFondeoSE = 0;
      this.totalClienteCE = 0;
      this.totalClienteRI = 0;
      this.totalClienteRE = 0;
      this.totalSupplierSE = 0;
      this.totalSupplierRI = 0;
      this.totalSupplierRE = 0;
      this.totalMensII = 0;
      this.totalMensIE = 0;
      this.totalMensCE = 0;
      this.totalMensRI = 0;
      this.totalMensRE = 0;

      this.$vs.notify({
        title: 'Cargando...',
        text: 'Espere un momento',
        color: 'dark',
        position: 'bottom-center',
        icon: 'access_time'
      })

      axios.get(`/api/project/${this.project_id}/validations`)
        .then((response) => {
          this.$vs.notify({
            title: '¡Listo!',
            text: 'Validaciones cargadas correctamente',
            color: 'success',
            position: 'bottom-center',
            icon: 'done'
          })
          this.validaciones = response.data.validaciones;
        }).catch(error => {
        this.showError(error);
      });

      axios.get(`/api/project/${this.project_id}/balance`)
        .then((response) => {
          this.$vs.notify({
            title: '¡Listo!',
            text: 'Balance cargado correctamente',
            color: 'success',
            position: 'bottom-center',
            icon: 'done'
          })
          this.fondeo = response.data.fondeo;
          this.cliente = response.data.cliente;
          this.instalador = response.data.instalador;
          this.mensualidades = response.data.mensualidades;
          this.totalFondeoII = response.data.totalFondeoII;
          this.totalFondeoIE = response.data.totalFondeoIE;
          this.totalFondeoCI = response.data.totalFondeoCI;
          this.totalFondeoCE = response.data.totalFondeoCE;
          this.totalFondeoSI = response.data.totalFondeoSI;
          this.totalFondeoSE = response.data.totalFondeoSE;
          this.totalClienteCE = response.data.totalClienteCE;
          this.totalClienteRI = response.data.totalClienteRI;
          this.totalClienteRE = response.data.totalClienteRE;
          this.totalSupplierSE = response.data.totalSupplierSE;
          this.totalSupplierRI = response.data.totalSupplierRI;
          this.totalSupplierRE = response.data.totalSupplierRE;
          this.totalMensII = response.data.totalMensII;
          this.totalMensIE = response.data.totalMensIE;
          this.totalMensCE = response.data.totalMensCE;
          this.totalMensRI = response.data.totalMensRI;
          this.totalMensRE = response.data.totalMensRE;
        }).catch(error => {
        this.showError(error);
      });
      this.buscando = false;
    },
    showError(error) {
      this.buscando = false;
      console.log(error);
      this.$vs.notify({
        title: '¡ERROR!',
        text: 'Algo salió mal...',
        color: 'danger',
        position: 'bottom-center',
        icon: 'error'
      })
    }
  },
  computed: {}
}
</script>
